var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',_vm._b({},'b-col',{ id: _vm.id, col: _vm.col, cols: _vm.cols, sm: _vm.sm, md: _vm.md, lg: _vm.lg, xl: _vm.xl },false),[_c('WidgetGroup',{attrs:{"widgets":_vm.childrenSlots.default}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }